import React, { useContext } from 'react';
import { useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {Accordion, AccordionDetails, AccordionSummary, FormGroup, FormLabel, TextField} from "@mui/material";
import WaitSpinner from "../../components/wait-spinner";
import {SelectId} from "../../components/MaterialSelects/SelectId";
import {
     Option
} from "../../generated/graphql";
import { HtmlEditor } from '../../components/html-editor';

function OptionForm({diaForm,waiting}) {
    const {errors,handleSubmit,onChange,isDirty,status} = diaForm;
    const values:Option = diaForm.values;
    const id = values?.id;
    const isNew = id === 'new';
    const baseUrl = '/database/options/';
    const toolbarContext = useContext(ToolbarContext);
    const field = {
        onChange: onChange,
    };
    useEffect(() => {
        const buttons = [{
            type: 'button',
            icon: 'save',
            tooltip: 'Save',
            callback: handleSubmit,
            label: 'Save',
            disabled: !isDirty
        }];
        toolbarContext.setSecondary(
            {
                primaryUrl:baseUrl,
                title: (!isNew ? values.label : 'New Option'),
                secondary: buttons,
                secondaryUrl: id
            });
    }, [isDirty, id, status]);
    return (
        <Accordion defaultExpanded={true}>
            {waiting && <WaitSpinner variant="overlay"/>}
            <AccordionSummary>Option</AccordionSummary>
            <AccordionDetails className="grid12">
                <div className="grid12">
                    <TextField {...field} label="Label" name="label" value={values.label}
                                error={!!errors?.label} className="grid12-5"/>
                    <TextField label="Code" className="grid12-5" {...field} name="code" value={values.code}
                                error={!!errors?.code} />
                    <SelectId className="grid12-2" valueIsId={true} {...field} name="type" value={values.type} label="Type"
                                error={!!errors?.type} options={[{ id: 'html', name: 'HTML' }]} />

                    {values.type == 'html' &&
                        <>
                            <FormGroup className="grid12-span" style={{paddingBottom: '40px'}}><FormLabel>Value</FormLabel>
                                {/*<RichText value={values.text_value} name="text_value" onChange={field.onChange} initializeOnChange={values.id}/>*/}
                                {/* this component does not accept live updates, so recreate it by changing the id on record change */}
                                {[<HtmlEditor key={id+'-'+(waiting?'yes':'no')} {...field} name="text_value" value={values.text_value} className="grid12-span" loading={false}/>]}
                            </FormGroup>
                        </>
                    }
                </div>
            </AccordionDetails>
        </Accordion>
    );
}

export default OptionForm;
